import { useThemePrimaryTagsQuery } from "entities/themeTagTypes/queries/useThemePrimaryTagsQuery";
import { useThemeTagsListQuery } from "entities/themeTags/queries/useThemeTagListQuery";
import { ThemeTag } from "entities/themeTags/types";
import groupBy from "lodash/groupBy";
import { useMemo } from "react";
import { GameTagBlock } from "../../../stores/useGameTagsData";

type Props = {
  id: string;
  primaryTagId: string | null;
  tagBlocks: GameTagBlock[];
};

export const useThemeTagsOptions = ({ id, primaryTagId, tagBlocks }: Props) => {
  const { data: themeTags = [] } = useThemeTagsListQuery();
  const { data: themePrimaryTags } = useThemePrimaryTagsQuery();

  const groupedRawThemeTags: Record<string, ThemeTag[]> = useMemo(
    () => groupBy(themeTags, "tagType"),
    [themeTags],
  );

  const secondaryThemeTags = useMemo(() => {
    if (primaryTagId) {
      return (
        groupedRawThemeTags[primaryTagId]?.map((tag) => ({
          id: tag.id,
          name: tag.name,
        })) ?? []
      );
    }

    return [];
  }, [groupedRawThemeTags, primaryTagId]);

  const themePrimaryTagOptions =
    themePrimaryTags
      ?.filter((primaryTag) => {
        const isAlreadySelected = tagBlocks.some(
          (block) => block.id !== id && block.primaryTagId === primaryTag.id,
        );

        return !isAlreadySelected;
      })
      .map((primaryTag) => ({
        value: primaryTag.id,
        label: primaryTag.name,
      })) ?? [];

  return {
    secondaryThemeTags,
    themePrimaryTagOptions,
  };
};
